import { createFileRoute } from '@tanstack/react-router';

import { ActivityLogTable } from 'component/partial/tables/logs/ActivityLog/ActivityLogTable';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/logs/')({
  component: LogsIndexRoute,
});

function LogsIndexRoute() {
  return <ActivityLogTable />;
}
